import { MapContainer, TileLayer, FeatureGroup, Marker, Tooltip, LayersControl, useMap } from "react-leaflet";
import L from "leaflet";
import 'leaflet.fullscreen';
import 'leaflet.fullscreen/Control.FullScreen.css'; // Import the CSS for fullscreen button
import React from "react";
export const MAPS_CONFIG = {
    maptiler: {
        OPEN_STREET: {
            url: "https://api.maptiler.com/maps/basic/256/{z}/{x}/{y}.png?key=fXmTwJM642uPLZiwzhA1",
            attribution:
                '&copy; <a href="https://www.maptiler.com/">MapTiler</a> &copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        },

        GOOGLE: {
            url: 'http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}',
            attribution: 'google'
        }
    },
    source: ['GOOGLE', 'OPEN_STREET'],
    markerIcon: new L.Icon({
        iconUrl: require("../../../assets/icons/marker.png").default,
        iconSize: [40, 40],
        iconAnchor: [17, 46], //[left/right, top/bottom]
        popupAnchor: [0, -46], //[left/right, top/bottom]
    }),
    FinishPointIcon: new L.Icon({
        iconUrl: require("../../../assets/icons/green_marker.svg").default,
        iconSize: [40, 40],
        iconAnchor: [17, 46], //[left/right, top/bottom]
        popupAnchor: [0, -46], //[left/right, top/bottom]
    }),
    draw: {
        toolbar: {
            buttons: {
                polyline: 'Draw the quarters line',
                polygon: 'Draw a hole',
                circle: 'Select Tee and Finish Point',
            }
        }
    },
    edit: {
        toolbar: {
            buttons: {
                edit: "Edit area, lines and point"
            }
        },
        handlers: {
            remove: {
                tooltip: {
                  text: 'Click on a feature to remove.'
                }
            }
        }
    },
    fullscreenOptions: {
        position: 'bottomright', // change the position of the button can be topleft, topright, bottomright or bottomleft, default topleft
        title: 'Enter fullscreen', // change the title of the button, default Full Screen
        titleCancel: 'Exit fullscreen mode', // change the title of the button when fullscreen is on, default Exit Full Screen
        content: `<div style="width: 20rem; border-radius: 10px; font-size: 1.8rem; font-family: 'Jost', sans-serif; margin: -4rem -16.5rem; padding: 0.5rem 1rem; background-color: white">Enter/Exit Fullscreen</div>`, // change the content of the button, can be HTML, default null
        forceSeparateButton: true, // force separate button to detach from zoom buttons, default false
        forcePseudoFullscreen: true, // force use of pseudo full screen even if full screen API is available, default false
    }
};

// Map component to initialize fullscreen control
const FullscreenControl = () => {
    const map = useMap();

    React.useEffect(() => {
        // Add fullscreen control when the map is initialized
        L.control.fullscreen({
            position: 'bottomright',
            title: 'Enter fullscreen',
            titleCancel: 'Exit fullscreen mode',
            content: `<div style="width: 20rem; border-radius: 10px; font-size: 1.8rem; font-family: 'Jost', sans-serif; margin: -4rem -16.5rem; padding: 0.5rem 1rem; background-color: white">Enter/Exit Fullscreen</div>`,
            forceSeparateButton: true,
            forcePseudoFullscreen: true,
        }).addTo(map);
    }, [map]);

    return null;
};

export const TeePointMarker = ({ coords, msg = '' }) => (
    <Marker
        position={coords}
        zIndexOffset={999}
    >
        <Tooltip permanent offset={[15, -40]}>
            <b>
                {/* {msg} */}
            </b>
        </Tooltip>
    </Marker>
);

export const renderGeoJson = (_geoJsonData, featureGroupRef) => {
    try {
        // Populate the leaflet FeatureGroup with the GeoJSON layers
        let leafletGeoJSON = new L.GeoJSON(_geoJsonData);
        console.log(leafletGeoJSON, "leafletGeoJson");
        if (!leafletGeoJSON) return;

        leafletGeoJSON.eachLayer((layer) => {
            try {
                // Adding tooltip to the shape if available
                try {
                    const { label, ...rest } = layer.feature.properties['toolTip'];

                    // Modify the border color and fill based on label
                    if (label === "Hole") {
                        layer.options = { 
                            ...layer.options, 
                            color: "black",  // Set border color
                            fillColor: "transparent",  // Transparent fill
                            fillOpacity: 0,  // No fill
                            opacity: 2, // Border opacity
                            weight: 2 // Border thickness
                        };
                    }

                    if (label === "White Tee") {
                        layer.options = { 
                            ...layer.options, 
                            color: "white",  // White border color
                            fillColor: "transparent", 
                            opacity: 2, 
                            weight: 2 
                        };
                    }

                    if (label === "Yellow Tee") {
                        layer.options = { 
                            ...layer.options, 
                            color: "yellow",  // Yellow border color
                            fillColor: "transparent", 
                            fillOpacity: 0, 
                            opacity: 0.5, 
                            weight: 2 
                        };
                    }

                    if (label === "Red Tee") {
                        layer.options = { 
                            ...layer.options, 
                            color: "red",  // Red border color
                            fillColor: "transparent", 
                            fillOpacity: 0, 
                            opacity: 0.5, 
                            weight: 2 
                        };
                    }

                    if (label === "Finish Point") {
                        layer.options = { 
                            ...layer.options, 
                            icon: MAPS_CONFIG.FinishPointIcon  // Custom marker icon
                        };
                    }

                    // Bind tooltip
                    layer.bindTooltip(function (layer) {
                        return label; // Tooltip text
                    }, rest);
                } catch (e) {
                    console.error("Error applying styles or tooltips", e);
                }

                // Add the layer to the feature group
                featureGroupRef.addLayer(layer);
            } catch (e) {
                console.error("Error adding layer to feature group", e);
            }
        });

    } catch (e) {
        console.error('Unable to render geoJson data', _geoJsonData);
    }
};


export const cleanPreviousHoleLayers = (geoJsonData, featureGroupRef) => {
    let layerContainer = featureGroupRef;
    let layers = Object.values(featureGroupRef._layers);

    let removable_layer_ids = Object.keys(layers);

    console.log(featureGroupRef, removable_layer_ids, "layers");

    removable_layer_ids.forEach(id => {
        let layer = layers[id];
        layerContainer.removeLayer(layer);
    });
};
